import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

/**
 * Just a simple component that renders a checkbox and label. Provides onChange callback prop.
 */
function CheckboxOption({ intl, checked, onChange, label }) {
  return (
    <label htmlFor={`${label}-toggle`}>
      <input
        type="checkbox"
        id={`${label}-toggle`}
        onChange={e => onChange(!checked)}
        checked={checked}
        title={intl.formatMessage({
          id: `toggle_${label}_hover`
        })}
      />
      <span
        title={intl.formatMessage({
          id: `toggle_${label}_hover`
        })}
      >
        {intl.formatMessage({
          id: `toggle_${label}_column`
        })}
      </span>
    </label>
  );
}

CheckboxOption.propsTypes = {
  // True if the checkbox is toggled on
  checked: PropTypes.bool.isRequired,
  // Label for translation message lookup
  label: PropTypes.string.isRequired,
  // Callback fired when checkbox is toggled
  onChange: PropTypes.func,
  intl: PropTypes.object
};

export default injectIntl(CheckboxOption);
